import React from 'react';
import dayjs from 'dayjs';

//Estilos
import './NewDJCP.css';
import TableContainer from '../../components/table/TableContainer';

function NewDJCP({ functions, states }) {
    const { tableData, DJCPData, DJCPCerrada } = states;

    const {
        register,
        handleSubmit,
        onSubmit,
        formState: { errors },
    } = functions;

    const Titulares = DJCPData?.cabecera?.titulares?.split('/');

    return (
        <div className="newDJCP-container">
            <form className="newDJCP-form" onSubmit={handleSubmit(onSubmit)}>
                <h4>
                    {`Declaración Jurada de Cosecha Probable ${DJCPData?.cabecera?.serie}-P-${DJCPData?.cabecera?.numero} para viñedo ${DJCPData?.cabecera?.viniedo}`}
                </h4>
                {Titulares?.map((t, i) => {
                    return (
                        <div key={i} className="newDJCP-titular_container">
                            <label className="newDJCP-label">
                                <span>Titular: </span>
                                <p>{t}</p>
                            </label>
                            <label className="newDJCP-label">
                                <div>
                                    <span>Nro de Documento / RUT: </span>
                                    <input
                                        className="signup-input"
                                        type="number"
                                        {...register(
                                            `cabecera.titulares_Documento[${i}]`,
                                            {
                                                required:
                                                    'Debe ingresar un documento de identidad',
                                                validate: {
                                                    minLength: (v) =>
                                                        v.length >= 8 ||
                                                        'El número de documento debe tener un mínimo de 8 caracteres',
                                                },
                                            }
                                        )}
                                        onKeyPress={(e) => {
                                            if (
                                                !/[A-Za-z0-9]+/.test(e.key) ||
                                                e.target.value.length > 15
                                            ) {
                                                e.preventDefault();
                                            }
                                        }}
                                        disabled={DJCPCerrada}
                                    />
                                </div>
                                {errors.cabecera?.titulares_Documento[i] && (
                                    <small className="form__error">
                                        {
                                            errors.cabecera
                                                ?.titulares_Documento[i]
                                                ?.message
                                        }
                                    </small>
                                )}
                            </label>
                        </div>
                    );
                })}
                <TableContainer tableData={tableData} />
                <div className="newDJCP-footer">
                    <button
                        type="submit"
                        className="btn btn-primary btn-submit-newDJCP"
                        disabled={DJCPCerrada}
                    >
                        Guardar
                    </button>
                </div>
            </form>
        </div>
    );
}

export default NewDJCP;
